import {AfterViewInit,Component,OnInit, ViewChild} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {MatPaginator,MatPaginatorIntl} from '@angular/material/paginator';
import {MatSort} from '@angular/material/sort';
import {MatTableDataSource} from '@angular/material/table';
import { DatePipe ,registerLocaleData} from '@angular/common';
import { UserService } from '../services/user.service';
import {FormControl, FormGroup} from '@angular/forms';
import localeFr from '@angular/common/locales/fr';
import {DateAdapter, MAT_DATE_FORMATS, MAT_DATE_LOCALE} from '@angular/material/core';
registerLocaleData(localeFr, 'fr');
import * as _moment from 'moment';
import { MatInput } from '@angular/material';


export interface Archive {
  uuid: string;
  count: string;
  start_at: string;
  updated_at: string;
}

export interface UserData {
  id: string;
  name: string;
  catalogue: string;
  date_: Date;
}

@Component({
  selector: 'app-archives',
  templateUrl: './archives.component.html',
  styleUrls: ['./archives.component.css']
 })
export class ArchivesComponent implements OnInit,AfterViewInit {

  displayedColumns: string[] = ['id','name','catalogue', 'date','delete'];
  //public dataSource: MatTableDataSource<Archive>;;
  public dataSource;
  archives = [];
  
  @ViewChild(MatPaginator,{static: false}) paginator: MatPaginator;
  @ViewChild(MatSort,{static: false}) sort: MatSort;
  @ViewChild('inputFrom',{ read: MatInput ,static: false}) inputFrom: MatInput;
  @ViewChild('inputTo',{ read: MatInput ,static: false}) inputTo: MatInput;

  filterForm = new FormGroup({
    fromDate: new FormControl(),
    toDate: new FormControl(),
});


  constructor(private _httpClient: HttpClient,private userService: UserService,private pipe: DatePipe,private _adapter: DateAdapter<any>,private paginatorIntl :MatPaginatorIntl) {
    

    this.paginatorIntl.itemsPerPageLabel = 'Pdfs par page:';
    this.paginatorIntl.nextPageLabel = 'Page suivante';
    this.paginatorIntl.previousPageLabel = 'Page précédente';



    this.userService.getArchives(this.userService.getCurrentUser().id,"swao").subscribe(data => {
      this.archives.push(data.data);
      
      });  

       
    this.dataSource = new MatTableDataSource(this.archives);
    this._adapter.setLocale('fr');
    this.pipe = new DatePipe('fr-FR');
 
    this.dataSource.filterPredicate = (data, filter) =>{
     let date = new Date(data.Created_at);
  
 
      if (this.fromDate && this.toDate) {
        return date >=  this.fromDate &&  date <= this.toDate;
      }
      return true;
    }




  


  
 
  }

  

  

  ngOnInit() {
    this.getAllArchives();
 
   
  }
 
  public getAllArchives = () => {

 
  }
  ngAfterViewInit(): void {
    this.dataSource.paginator = this.paginator;
    this.dataSource.sort = this.sort;
   
  }
  get fromDate() { return this.filterForm.get('fromDate').value;
    }
  get toDate() { return this.filterForm.get('toDate').value; }

  applyFilter() {
    this.dataSource.filterPredicate = (data, filter) =>{
      let date = new Date(data.date);
   
  
       if (this.fromDate && this.toDate) {
         return date >=  this.fromDate &&  date <= this.toDate;
       }
       return true;
     }
    this.dataSource.filter = ''+Math.random();

   
  }
  reset() {
      this.inputFrom.value ='';
    this.inputTo.value ='';
  
    this.dataSource.filterPredicate = (data, filter) =>{
      let date = new Date(data.date);
   
         return true;
     }
     this.dataSource.filter = ''+Math.random();

    
  }
  myFilter = (d: Date | null): boolean => {
    const day = (d || new Date()).getDay();
    
    return day !== 0 && day !== 6;
  }
  getInputVadator():boolean{
    return    this.fromDate === null &&   this.toDate === null;

   //this.inputFrom.value ==='' &&  this.inputTo.value ==='';

  }
  

}
